import { render, staticRenderFns } from "./modal_registrarMaterialAseo.vue?vue&type=template&id=1f05377d&"
import script from "./modal_registrarMaterialAseo.vue?vue&type=script&lang=js&"
export * from "./modal_registrarMaterialAseo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports